import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link, useNavigate } from 'react-router';

import { PageTitle } from '@src/components/common';
import ContactUsLink from '@src/components/ContactUsLink';

import styles from './error.scss';

const Error404 = ({ type = 'page' }) => {
    const navigate = useNavigate();

    const handleBack = (e) => {
        e.preventDefault();
        navigate(-1);
    };

    return (
        <Container id="home" className={styles.error_page}>
            <PageTitle title="Page Not Found" />
            <Row>
                <Col className="text-center">
                    <div className="error-container">
                        <img src="/img/404-icon.svg" alt="Magnifying Glass" />
                        <h1>Oops!</h1>
                        <h2>That {type} could not be found.</h2>
                        <p>Try another URL or <a className="link-primary" onClick={handleBack} >go back to a previous page</a>.</p>
                        <p>For more support please <ContactUsLink>contact us</ContactUsLink>.</p>
                        <p>Or <Link to="/search" className="link-primary">Search</Link> for content here</p>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

Error404.propTypes = {
    type: PropTypes.string,
};

export default Error404;
